import { useEffect } from "react";
import { useAtomValue } from "jotai";

import { participantIdAtom, romIdAtom } from "@/atoms/rom.atoms";
import { romService } from "@/services/rom.service";

/**
 * Attaches a `beforeunload` + `pagehide` handler that fires a best-effort
 * leave request via `navigator.sendBeacon` so the backend closes the rom
 * immediately when the guest tab closes, instead of waiting for the
 * heartbeat timeout.
 */
export function useRomLeaveOnUnload() {
  const romId = useAtomValue(romIdAtom);
  const participantId = useAtomValue(participantIdAtom);

  useEffect(() => {
    if (!romId || !participantId) return;

    const handler = () => {
      romService.leaveBeacon(romId, participantId);
    };

    window.addEventListener("beforeunload", handler);
    window.addEventListener("pagehide", handler);

    return () => {
      window.removeEventListener("beforeunload", handler);
      window.removeEventListener("pagehide", handler);
    };
  }, [romId, participantId]);
}
